import { ColumnDef, createColumnHelper } from "@tanstack/react-table"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { IngestionResponses } from "@tfg/types/endpoints/ingestions"

import { DateCell } from "~/components/cells/DateCell.tsx"
import { DocumentActionsCell } from "~/components/cells/DocumentActionsCell.tsx"

const columnHelper = createColumnHelper<IngestionResponses.Ingestion>()
export const useColumns = () => {
  const { t } = useTranslation("dataTransfer")

  return useMemo<ColumnDef<IngestionResponses.Ingestion, any>[]>(
    () => [
      columnHelper.accessor("createdAt", {
        header: t("columns.createdAt"),
        cell: (info) => <DateCell date={info.getValue()} format="lll" />,
      }),
      columnHelper.accessor("productsCount", {
        header: t("columns.productsCount"),
      }),
      columnHelper.display({
        header: t("columns.document"),
        cell: (info) => {
          return (
            <DocumentActionsCell
              documentName={info.row.original.documentName}
              documentId={info.row.original.documentId}
            />
          )
        },
      }),
    ],
    [t]
  )
}
